export const GET_SURVEYS = 'app/get_surveys'

export const GET_SURVEY_BY_ID = 'app/survey_by_id'
export const DELETE_SURVEY_BY_ID = 'app/delete_survey'
export const CREATE_SURVEY = 'app/create_survey'
export const UPDATE_SURVEY = 'app/update_survey'
export const SET_SURVEY_CATEGORY = 'app/set_survey_category'
export const UPDATE_EPC = 'app/update_epc'
